<template>
  <div>
    <b-row>
      <b-col>
        <b-card>
          <template slot="header">
            Statistieken
          </template>
          <b-form-group label="Gemeentefilter">
            <b-form-select :options="municipalityOptions" v-model="municipality_id" @change="getCampaignActionStatistics()"/>
          </b-form-group>
          <hr>
          <b-card-title>Aantal acties</b-card-title>
          <GChart
            type="AreaChart"
            :data="chartData"
            :options="chartOptions"
          />
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import { GChart } from 'vue-google-charts'
  import {getData} from "../../api";

  export default {
    components: {
      GChart
    },
    name: 'statistics',
    data () {
      return {
        // Array will be automatically processed with visualization.arrayToDataTable function
        chartData: [],
        chartOptions: {
          chart: {
            title: 'Campagne acties'
          }
        },
        municipalityOptions: [],
        municipality_id: null,
      }
    },
    methods: {
      async getMunicipalityOptions() {
        this.municipalityOptions = await getData('municipalities').then(
          (response) => response.data.data
        );
        this.municipalityOptions.unshift({
          text: 'Mijn gemeentes',
          value: null,
        });
      },
      async getCampaignActionStatistics() {
        let address = 'statistics/campaign-actions';
        if(this.municipality_id != null) {
          address = address+'?municipality_id='+this.municipality_id;
        }
        this.chartData = await getData(address).then(
          (response) => response.data
        );
      },

    },
    beforeMount() {
      this.getCampaignActionStatistics();
      this.getMunicipalityOptions();
    },
  }
</script>
